module.exports = __webpack_public_path__ + "img/bonus_symbol_0.a1c71b31.png";